// LoadingSkeleton.jsx - Reusable skeleton loading component
import React from 'react';

const LoadingSkeleton = ({ type = 'card', count = 1 }) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'card':
        return (
          <div className="card mb-4">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="skeleton skeleton-text mb-2" style={{ height: '24px', width: '60%' }}></div>
                  <div className="skeleton skeleton-text mb-2" style={{ height: '16px', width: '80%' }}></div>
                  <div className="skeleton skeleton-text mb-2" style={{ height: '16px', width: '70%' }}></div>
                  <div className="skeleton skeleton-text mb-2" style={{ height: '16px', width: '90%' }}></div>
                </div>
                <div className="col-md-6">
                  <div className="skeleton skeleton-text mb-3" style={{ height: '20px', width: '40%' }}></div>
                  <div className="skeleton skeleton-text mb-2" style={{ height: '16px', width: '50%' }}></div>
                  <div className="skeleton skeleton-text mb-2" style={{ height: '16px', width: '45%' }}></div>
                  <div className="skeleton skeleton-text mb-2" style={{ height: '16px', width: '55%' }}></div>
                </div>
              </div>
            </div>
          </div>
        );
      case 'list':
        return (
          <div className="card mb-4">
            <div className="card-header">
              <div className="skeleton skeleton-text" style={{ height: '20px', width: '30%' }}></div>
            </div>
            <div className="card-body">
              {Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className="d-flex justify-content-between align-items-center border-bottom py-2 mb-2">
                  <div className="flex-grow-1">
                    <div className="skeleton skeleton-text mb-1" style={{ height: '18px', width: '70%' }}></div>
                    <div className="skeleton skeleton-text" style={{ height: '14px', width: '50%' }}></div>
                  </div>
                  <div className="skeleton skeleton-text" style={{ height: '16px', width: '20%' }}></div>
                </div>
              ))}
            </div>
          </div>
        );
      case 'order':
        return (
          <div className="col-12 mb-4">
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <div className="skeleton skeleton-text mb-2" style={{ height: '20px', width: '40%' }}></div>
                    <div className="skeleton skeleton-text mb-1" style={{ height: '14px', width: '60%' }}></div>
                    <div className="skeleton skeleton-text mb-1" style={{ height: '14px', width: '50%' }}></div>
                    <div className="skeleton skeleton-text" style={{ height: '16px', width: '30%' }}></div>
                  </div>
                  <div className="col-md-4 text-end">
                    <div className="skeleton skeleton-text" style={{ height: '36px', width: '100px' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="skeleton skeleton-text" style={{ height: '20px', width: '100%' }}></div>
        );
    }
  };

  return (
    <div className="loading-skeleton">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index}>
          {renderSkeleton()}
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;